import { useEffect } from "react";
import { useNavigate } from "react-router";
import type { User } from "firebase/auth";
import { useAdminAuth } from "./useAdminAuth";

/**
 * Returns the current Firebase Auth user and redirects to /login if unauthenticated.
 *
 * - `undefined` → still loading (show spinner, do not redirect)
 * - `null`      → not authenticated → redirect to /login
 * - `User`      → authenticated
 */
export function useAuthGuard(): User | null | undefined {
  const user = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) {
      void navigate("/login", { replace: true });
    }
  }, [user, navigate]);

  return user;
}
